import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "lead p-4 text-center"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, { ref: "dialog" }, {
    title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createTextVNode("Změna povinného parametru", -1)
    ]))]),
    body: _withCtx(() => [
      (_ctx.calculating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", {
              class: "spinner-border spinner-border-sm me-2 align-middle",
              role: "status"
            }, null, -1),
            _createTextVNode(" Přepočítávání ... ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "Změnili jste hodnotu některého z povinných parametrů.", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", null, "Chcete přepočítat odhad s novými nemovitostmi?", -1))
          ], 64))
    ]),
    buttons: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.recalculate())),
        disabled: _ctx.calculating
      }, " Přepočítat s novými nemovitostmi ", 8, _hoisted_2),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        "data-bs-dismiss": "modal",
        disabled: _ctx.calculating
      }, " Ponechat původní nemovitosti ", 8, _hoisted_3)
    ]),
    _: 1
  }, 512))
}